// extracted by mini-css-extract-plugin
export default {"header":"DepartmentListing-module__header__AyXvS"};